import api from './api';

const orderService = {
  // Get all orders for authenticated user
  getOrders: async () => {
    try {
      const response = await api.get('/orders/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch orders'
      };
    }
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    try {
      const response = await api.get(`/orders/${orderId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch order'
      };
    }
  },

  // Cancel order
  cancelOrder: async (orderId) => {
    try {
      const response = await api.delete(`/orders/${orderId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to cancel order'
      };
    }
  },

  // Partner: Get all orders
  getPartnerOrders: async (params = {}) => {
    try {
      const response = await api.get('/partner/orders/', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch partner orders'
      };
    }
  },

  // Partner: Get order by ID
  getPartnerOrderById: async (orderId) => {
    try {
      const response = await api.get(`/partner/orders/${orderId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch partner order'
      };
    }
  },

  // Partner: Update order status
  updateOrderStatus: async (orderId, data) => {
    try {
      const response = await api.patch(`/partner/orders/${orderId}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to update order status'
      };
    }
  },

  // Partner: Get revenue report
  getRevenueReport: async (params = {}) => {
    try {
      const response = await api.get('/partner/revenue-report/', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch revenue report'
      };
    }
  },

  // Create Stripe checkout session for order payment
  createPaymentSession: async (orderId) => {
    try {
      const response = await api.post(`/orders/${orderId}/pay/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to create payment session'
      };
    }
  },

  // Verify payment after Stripe redirect
  verifyPayment: async (sessionId, orderId) => {
    try {
      const response = await api.post('/orders/verify-payment/', {
        session_id: sessionId,
        order_id: orderId
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to verify payment'
      };
    }
  },

  // Create unified payment session for multiple orders
  createUnifiedPaymentSession: async (checkoutGroupId, orderIds) => {
    try {
      const response = await api.post('/orders/unified-pay/', {
        checkout_group_id: checkoutGroupId,
        order_ids: orderIds
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to create payment session'
      };
    }
  },

  // Verify unified payment after Stripe redirect
  verifyUnifiedPayment: async (sessionId, checkoutGroupId) => {
    try {
      const response = await api.post('/orders/verify-unified-payment/', {
        session_id: sessionId,
        checkout_group_id: checkoutGroupId
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to verify payment'
      };
    }
  },
};

export default orderService;
